











































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import discountDialog from '../../../components/discountDialog.vue';
import { WheelOption } from '@/model/FormWheel';

@Component({
  name: 'WheelOptionsCollapse',
  components: {
    discountDialog
  }
})
export default class WheelOptionsCollapse extends Vue {
  @Prop({ type: Array, required: true }) readonly value!: WheelOption[];

  activeNames: number[] = [];
  localOptions: WheelOption[] = [];

  // 动态折扣码对话框相关
  showDiscountDialog = false;
  currentDiscountIndex = -1;

  // 块颜色（按索引取色）
  blockColors: string[] = [
    '#FB4693', '#7A2DFF', '#30A8ED', '#4DD0B8', '#FF0000', '#818181', '#FFCA00', '#469C3D',
    '#8AD2C8', '#FE8157', '#673E12', '#803F56', '#D9A961', '#B8B8B8', '#EC6C6B', '#B0D8C7',
    '#EE5F31', '#498D80', '#97F5B2', '#21010C'
  ];

  created() {
    const incoming: any = Array.isArray(this.value) ? this.value : [];
    this.localOptions = this.withColors(this.clone(incoming));
    if (this.localOptions.length === 0) {
      this.localOptions.push({ color: this.getBlockColorByIndex(0), discountType: 1, coupon: '' });
    }
    // 如果默认只有一块，自动展开第一块
    if (this.localOptions.length === 1) {
      this.activeNames = [0];
    }
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
  }

  @Watch('value', { deep: true })
  onValueChange(v: WheelOption[]) {
    const incoming: any = Array.isArray(v) ? v : [];
    this.localOptions = this.withColors(this.clone(incoming));
    // 保底：至少 1 个占位，避免滑块处于 0 无法操作
    if (this.localOptions.length === 0) {
      this.localOptions = [{ color: this.getBlockColorByIndex(0), discountType: 2, coupon: '', discount: null }];
      this.emitChange();
    }
    // 如果默认只有一块，自动展开第一块
    if (this.localOptions.length === 1) {
      this.activeNames = [0];
    }
  }

  onBlockCountChange(nextCount: any) {
    const target = Number(Array.isArray(nextCount) ? nextCount[0] : nextCount) || 1;
    const current = this.localOptions.length;
    if (target > current) {
      const toAdd = target - current;
      for (let i = 0; i < toAdd; i += 1) {
        const nextIndex = current + i;
        this.localOptions.push({ color: this.getBlockColorByIndex(nextIndex), discountType: 1, coupon: '' });
      }
    } else if (target < current) {
      // 从末尾删除
      this.localOptions.splice(target);
    }
    window?.gtagClick('form_edit_setSlices','弹窗_编辑订阅工具_设置模版块数')
    this.emitChange();
  }

  emitChange() {
    // 确保浅拷贝，避免父级被意外引用
    this.$emit('input', this.clone(this.localOptions));
    this.$emit('change', this.clone(this.localOptions));
    console.log('emitChange', this.clone(this.localOptions));
  }

  toggle(idx: number) {
    const i = this.activeNames.indexOf(idx);
    if (i >= 0) {
      this.activeNames.splice(i, 1);
    } else {
      this.activeNames.push(idx);
    }
  }

  clone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
  }

  onOptionsChange() {
    // 概率或角度变更时，同步回父组件
    this.emitChange();
  }

  onSetCoupon(index: number) {
    // 打开动态折扣码设置对话框
    this.currentDiscountIndex = index;
    this.showDiscountDialog = true;
  }

  onCouponTypeChange(index: number) {
    const opt = this.localOptions[index];
    if (opt.discountType === 1) {
      // 固定折扣码：清空动态折扣码配置
      opt.discount = null;
      opt.coupon = opt.coupon || '';
    } else if (opt.discountType === 2) {
      // 动态折扣码：清空固定折扣码
      opt.coupon = '';
      // 交互对齐：选中动态折扣码即弹出设置弹窗
      this.currentDiscountIndex = index;
      this.showDiscountDialog = true;
    }
    this.emitChange();
  }

  // 保存动态折扣码配置
  saveDiscount(discount: any) {
    console.log('saveDiscount', discount);
    if (this.currentDiscountIndex >= 0) {
      const opt = this.localOptions[this.currentDiscountIndex];
      opt.discount = discount;
      opt.coupon = ''; // 清空固定折扣码
      this.emitChange();
    }
    this.showDiscountDialog = false;
    this.currentDiscountIndex = -1;
  }

  // 关闭动态折扣码对话框
  closeDiscount() {
    this.showDiscountDialog = false;
    this.currentDiscountIndex = -1;
  }

  // 取块颜色
  getBlockColor(index: number): string {
    const opt: any = this.localOptions?.[index] || {};
    if (opt && typeof opt.color === 'string' && opt.color) return opt.color;
    return this.getBlockColorByIndex(index);
  }

  // 按索引从默认色板取色
  getBlockColorByIndex(index: number): string {
    if (!this.blockColors || this.blockColors.length === 0) return '#CCCCCC';
    const i = Math.abs(Number(index)) % this.blockColors.length;
    return this.blockColors[i];
  }

  // 为现有选项补齐颜色字段
  withColors(options: any[]): any[] {
    if (!Array.isArray(options)) return [];
    return options.map((opt, idx) => {
      const color = (opt && typeof opt.color === 'string' && opt.color) ? opt.color : this.getBlockColorByIndex(idx);
      return { ...(opt || {}), color };
    });
  }
}
